module.exports = __webpack_public_path__ + "img/w53b.9f847fb8.jpg";